import { Link } from "react-router-dom";
import { ArrowUpRight, CalendarDays, Newspaper } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { mediaUrl } from "@/context/SettingsContext";

export const CAT_STYLE = { promo: "bg-gold text-white", service: "bg-brand text-white", atelier: "bg-forest text-white", info: "bg-mint text-brand" };

export const fmtNewsDate = (iso, lang) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString(lang === "fr" ? "fr-FR" : "en-GB", { day: "numeric", month: "long", year: "numeric" });

export const NewsMeta = ({ item, testid }) => {
  const { t, lang } = useLanguage();
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid={testid}>
      <span className={`rounded-full px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] ${CAT_STYLE[item.category] || CAT_STYLE.info}`}>{t.news.categories[item.category] || item.category}</span>
      <span className="inline-flex items-center gap-1.5 text-xs text-brand-hover"><CalendarDays className="h-3.5 w-3.5" />{fmtNewsDate(item.published_at, lang)}</span>
    </div>
  );
};

export const NewsCard = ({ item, featured = false, index = 0 }) => {
  const { t } = useLanguage();
  return (
    <Link to={`/actualites/${item.id}`} data-testid={`news-card-${index}`} className={`group flex h-full flex-col overflow-hidden rounded-3xl border border-brand/10 bg-white transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-2xl hover:shadow-gold/10 ${featured ? "lg:flex-row" : ""}`}>
      {item.image_url ? (
        <div className={`overflow-hidden ${featured ? "lg:w-1/2" : "aspect-[16/9]"}`}>
          <img src={mediaUrl(item.image_url)} alt={item.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        </div>
      ) : featured && (
        <div className="dots-bg hidden items-center justify-center bg-mint lg:flex lg:w-2/5">
          <span className="flex h-24 w-24 items-center justify-center rounded-3xl bg-white text-brand shadow-xl shadow-brand/10 transition-transform duration-500 group-hover:scale-105"><Newspaper className="h-10 w-10" /></span>
        </div>
      )}
      <div className={`flex flex-1 flex-col p-7 ${featured ? "lg:justify-center lg:p-10" : ""}`}>
        <NewsMeta item={item} />
        <h3 className={`font-display mt-4 font-bold leading-snug text-forest transition-colors group-hover:text-gold ${featured ? "text-2xl sm:text-3xl" : "text-lg sm:text-xl"}`}>{item.title}</h3>
        {item.summary && <p className={`mt-3 leading-relaxed text-brand-hover ${featured ? "text-base" : "line-clamp-3 text-sm"}`}>{item.summary}</p>}
        <span className="mt-auto inline-flex items-center gap-2 pt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-gold">
          {t.news.read}<ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </span>
      </div>
    </Link>
  );
};
